
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/prihlaseni",
      function () {
        return require("private-next-pages/prihlaseni.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/prihlaseni"])
      });
    }
  